import { ReactElement, useCallback } from 'react';
import { getAcademicHistoryGrades } from '../../../../../api/academicHistoryRequests';
import { CourseHistory } from '../types';

import { createFetchContext } from '../../../../../../../../components/contexts/FetchContextFactory';
import { AuthenticationError } from '../../../../../../../GradeEntry/Loaders/CreateEvaluationGradeEntryBaseLoader';
import { AxiosResultDefaultError } from '../../../../../../../../api/request';
import DisplayError from '../../../../../../../../components/Info/DisplayError';
import Loading from '../../../../../../../../components/Info/Loading';
export interface BaseLoaderProps {
  studyPlanEnrollmentId: number | string;
  onError?: (code: string, onUnknown?: (() => void) | undefined) => void;
  children: (props: { history: CourseHistory }) => ReactElement;
}

const { FetchProvider, FetchConsumer } = createFetchContext<
  undefined,
  CourseHistory,
  AuthenticationError | AxiosResultDefaultError
>();

export const GradesHistoryLoaderConsumer = FetchConsumer;

export default function BaseLoader({
  studyPlanEnrollmentId,
  onError,
  children,
}: BaseLoaderProps) {
  const request = useCallback(() => {
    return getAcademicHistoryGrades(studyPlanEnrollmentId);
  }, [studyPlanEnrollmentId]);

  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      <FetchConsumer>
        {({ data, loading, error, refresh }) => {
          if (error) {
            onError && onError(error.code);
            return (
              <DisplayError
                insideCard
                textBody={error.code}
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          if (loading) {
            return <Loading insideCard />;
          }

          if (!data) {
            return (
              <DisplayError
                insideCard
                textBody="Data no cargada"
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }
          return children({
            history: data,
          });
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
